import { create } from 'zustand';

export type ToastLevel = 'info' | 'success' | 'warn' | 'error';

export interface Toast {
  id: number;
  level: ToastLevel;
  message: string;
}

interface ToastState {
  toasts: Toast[];
  push(level: ToastLevel, message: string, ttlMs?: number): void;
  dismiss(id: number): void;
}

let nextId = 1;

export const useToasts = create<ToastState>()((set, get) => ({
  toasts: [],
  push(level, message, ttlMs = level === 'error' ? 8000 : 4000) {
    const id = nextId++;
    set({ toasts: [...get().toasts.slice(-4), { id, level, message }] });
    setTimeout(() => get().dismiss(id), ttlMs);
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
}));

export const toast = {
  info: (m: string) => useToasts.getState().push('info', m),
  success: (m: string) => useToasts.getState().push('success', m),
  warn: (m: string) => useToasts.getState().push('warn', m),
  error: (m: string) => useToasts.getState().push('error', m),
};

export function errorMessage(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
